exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header {\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  width: 100%;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.header .header-item {\r\n  width: 50%;\r\n}\r\n\r\n.form-submit-button {\r\n  margin-top: 10px;\r\n  text-align: center;\r\n}\r\n\r\n.width50 {\r\n  width: 50%;\r\n}\r\n\r\n.width50 md-input-container {\r\n  width: 100%;\r\n}\r\n\r\n#type-manager {\r\n  margin-top: 10px;\r\n}\r\n\r\n#published {\r\n  margin-top: 15px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-manager/item-manager.component.css
// module id = ../../../../../src/app/components/utils/item-manager/item-manager.component.css
// module chunks = main